import { render, staticRenderFns } from "./NewsroomSearch.vue?vue&type=template&id=0a5145e2&scoped=true"
import script from "./NewsroomSearch.vue?vue&type=script&lang=js"
export * from "./NewsroomSearch.vue?vue&type=script&lang=js"
import style0 from "./NewsroomSearch.vue?vue&type=style&index=0&id=0a5145e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5145e2",
  null
  
)

export default component.exports